import { DashboardFigure } from "@components/Dashboards/shell";

type Props = {
  totalUsers?: number;
  prominent?: boolean;
};

export const ResourceGroupTotalUsersStat = ({
  totalUsers,
  prominent,
}: Props) => {
  return (
    <DashboardFigure
      prominent={prominent}
      label="Total users"
      value={totalUsers?.toString() ?? "0"}
      detail="All time"
    />
  );
};
